<template>
    <div class="uk-form-controls quantity-selector uk-flex-inline uk-flex-middle">
        <div :class="buttonsClasses" @click="decrease">
            <i class="fal fa-minus"></i>
        </div>

        <input class="uk-input uk-form-small uk-form-width-small" type="number" :name="name" v-model="appliedValue" v-bind="inputAttributes">

        <div :class="buttonsClasses" @click="increase">
            <i class="fal fa-plus"></i>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      name: {
        type: String,
        default: 'quantity',
      },
      value: {
        type: Number,
        default: 1,
      },
      inputAttributes: {
        type: Object,
        default: () => ({
          readonly: true,
          required: true,
        }),
      },
      buttonsClasses: {
        type: String,
        default: 'uk-button uk-button-primary uk-button-small quantity-add',
      },
      global: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        appliedValue: this.value,
      };
    },
    watch: {
      appliedValue() {
        this.changed();
      },
    },
    methods: {
      decrease() {
        if (this.appliedValue > 1) {
          this.appliedValue--;
        }
      },
      increase() {
        this.appliedValue++;
      },
      reset() {
        this.appliedValue = this.value;
      },
      changed() {
        if(this.global) {
          window.App.$emit('quantity-changed', this.appliedValue, this);
        } else {
          this.$emit('quantity-changed', this.appliedValue, this);
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/assets/js/theme-components/QuantityInput.vue